<template>
<div class="flex-container" id="contact">

    <!-- If they have clicked yes -->
    <div id="generalEnquiryContainer" class="flex-item col-12 flex-container">
      <h3></h3>

      <form id="form" class="flex-item col-12 margin-0" v-on:submit.prevent="submit">
        <div class="flex-item col-12">
          <i class="required">{{translations.allfeilds1}} <span>*</span> {{translations.allfeilds2}}</i>
        </div>

        <div class="flex-item col-12" >
          <label for="orderNumber">{{translations.ordernumber}} <span>*</span></label>
          <input v-model="orderNumber" type="number" required class="form-control" id="orderNumber" placeholder="21686939">
          <small class="form-text text-muted">{{translations.ordernumberhelp}}</small>
        </div>

        <div class="flex-item col-12">
          <label for="fullName">{{translations.fullName}} <span>*</span></label>
          <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder">
        </div>

        <div class="flex-item col-12">
          <label for="email">{{translations.email}} <span>*</span></label>
          <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder">
          <small class="form-text text-muted">{{translations.neverShare}} <a v-if="translations.neverShareLink" href="https://www.regatta.pl/polityka-prywatnosci/" target="_blank">{{translations.neverShareLink}}</a> </small>

        </div>

        <div class="flex-item col-12">
          <label for="address">{{translations.address}} <span>*</span></label>
          <input v-model="address" type="text" required class="form-control" id="address" :placeholder="translations.addressSub">
        </div>

        <div class="flex-item col-12">
          <label for="city">{{translations.city}} <span>*</span></label>
          <input v-model="city" type="text" required class="form-control" id="city" :placeholder="translations.citySub">
        </div>

        <div class="flex-item col-12">
          <label for="country">{{translations.country}}: <span>*</span></label>
          <select v-model="country" id="country" data-parameter="Country" required class="form-control">
            <option value="" disabled default>{{translations.countrySelect}}</option>
            <option value="Ireland">Ireland</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="France">France</option>
            <option value="Poland">Polska</option>
            <option value="Germany">Germany</option>
            <option value="----" disabled>----</option>

            <option value="United States">United States</option>
            <option value="Australia">Australia</option>
            <option value="Canada">Canada</option>
            <option value="New Zealand">New Zealand</option>
            <option value="India">India</option>
            <option value="Brazil">Brazil</option>
            <option value="Afghanistan">Afghanistan</option>
            <option value="Åland Islands">Åland Islands</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="American Samoa">American Samoa</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Anguilla">Anguilla</option>
            <option value="Antarctica">Antarctica</option>
            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Aruba">Aruba</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>
            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bermuda">Bermuda</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
            <option value="Botswana">Botswana</option>
            <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
            <option value="Brunei Darussalam">Brunei Darussalam</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Cayman Islands">Cayman Islands</option>
            <option value="Central African Republic">Central African Republic</option>
            <option value="Chad">Chad</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Democratic Republic of the Congo">Democratic Republic of the Congo</option>
            <option value="Republic of the Congo">Republic of the Congo</option>
            <option value="Cook Islands">Cook Islands</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Côte d'Ivoire">Côte d'Ivoire</option>
            <option value="Croatia">Croatia</option>
            <option value="Cuba">Cuba</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>
            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>
            <option value="East Timor">East Timor</option>
            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Ethiopia">Ethiopia</option>
            <option value="Faroe Islands">Faroe Islands</option>
            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Ghana">Ghana</option>
            <option value="Gibraltar">Gibraltar</option>
            <option value="Greece">Greece</option>
            <option value="Grenada">Grenada</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guinea">Guinea</option>
            <option value="Guinea-Bissau">Guinea-Bissau</option>
            <option value="Guyana">Guyana</option>
            <option value="Haiti">Haiti</option>
            <option value="Honduras">Honduras</option>
            <option value="Hong Kong">Hong Kong</option>
            <option value="Hungary">Hungary</option>
            <option value="Iceland">Iceland</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Iran">Iran</option>
            <option value="Iraq">Iraq</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>
            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jordan">Jordan</option>
            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="North Korea">North Korea</option>
            <option value="South Korea">South Korea</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>
            <option value="Laos">Laos</option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libya">Libya</option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>
            <option value="Macedonia">Macedonia</option>
            <option value="Madagascar">Madagascar</option>
            <option value="Malawi">Malawi</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mexico">Mexico</option>
            <option value="Micronesia">Micronesia</option>
            <option value="Moldova">Moldova</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montenegro">Montenegro</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>
            <option value="Namibia">Namibia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherlands">Netherlands</option>
            <option value="Curacao">Curacao</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="Norway">Norway</option>
            <option value="Oman">Oman</option>
            <option value="Pakistan">Pakistan</option>
            <option value="Palau">Palau</option>
            <option value="Palestine">Palestine</option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Philippines">Philippines</option>
            <option value="Portugal">Portugal</option>
            <option value="Puerto Rico">Puerto Rico</option>
            <option value="Qatar">Qatar</option>
            <option value="Romania">Romania</option>
            <option value="Russia">Russia</option>
            <option value="Rwanda">Rwanda</option>
            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
            <option value="Saint Lucia">Saint Lucia</option>
            <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
            <option value="Samoa">Samoa</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Serbia">Serbia</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra Leone">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Sint Maarten">Sint Maarten</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="Spain">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Swaziland">Swaziland</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syria">Syria</option>
            <option value="Taiwan">Taiwan</option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania">Tanzania</option>
            <option value="Thailand">Thailand</option>
            <option value="Togo">Togo</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>
            <option value="Tuvalu">Tuvalu</option>
            <option value="Uganda">Uganda</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Emirates">United Arab Emirates</option>
            <option value="United States Minor Outlying Islands">United States Minor Outlying Islands </option>
            <option value="Uruguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>
            <option value="Vanuatu">Vanuatu</option>
            <option value="Vatican City">Vatican City</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Vietnam">Vietnam</option>
            <option value="Virgin Islands, British">Virgin Islands, British</option>
            <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
            <option value="Yemen">Yemen</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>
          </select>
        </div>



        <div class="flex-item col-12 mini">
          <label for="postCode">{{translations.postcode}} <span>*</span></label>
          <input v-model="postCode" type="text" required class="form-control" id="postCode" :placeholder="translations.postcodeplaceholder">
        </div>

        <div class="flex-item col-12 flex-container" v-if="successMessage === 'yes' " id="successMessage" @click="closeSuccessMessage()">
          <h2>{{translations.thankyou}}</h2>
          <div>{{translations.successmessage1}} {{translations.successmessage2}}</div>
        </div>

        <button type="submit" class="btn btn-primary">

          <div class="spinner-border" role="status" v-if="sendState === 'sending'">
            <span class="sr-only">{{translations.sending}} </span>
          </div>

          <div v-if="sendState != 'sending'">{{translations.submit}}</div>
        </button>



      </form>
    </div>





</div>
</template>

<script>
const axios = require('axios');
import jsonFile from './translations.json'

export default {
  name: 'app',
  mounted: function() {
    this.onPageLoad()
  },
  data() {
    return {
      newItem: '',
      state: 'default',
      brand: null,
      brandURL: null,
      newItemPurchase: '',
      statePurchase: 'default',
      faultyItemValue: 'default',

      sendState: 'default',
      orderNumber: null,
      fullName: null,
      email: null,
      address: null,
      city: null,
      postCode: null,
      country: '',

      token: 0,
      successMessage: null,
      translations: "",
    }
  },
  methods: {
    onPageLoad: function() {
      document.getElementsByTagName( 'html' )[0].setAttribute("data-brand", this.$router.currentRoute.params.pathMatch);
      document.getElementsByTagName( 'html' )[0].setAttribute("data-lang", this.$router.currentRoute.query.lang);
      console.log(this.$router.currentRoute.params.pathMatch);

      console.log(this.$router.currentRoute)
      this.brand =  this.$router.currentRoute.params.pathMatch
      var key = this.$router.currentRoute.query.lang
      var translationsUK = jsonFile.uk
      var translationsFR = jsonFile.fr
      var translationsDE = jsonFile.de
      var translationsPL = jsonFile.pl

      if (key == "uk") {
        this.translations = translationsUK
      }
      if (key == "us") {
        this.translations = translationsUK
      }
      if (key == "eu") {
        this.translations = translationsUK
      }
      if (key == "ie") {
        this.translations = translationsUK
      }
      if (key == "fr") {
        this.translations = translationsFR
      }
      if (key == "de") {
        this.translations = translationsDE
      }
      if (key == "pl") {
        this.translations = translationsPL
      }


    },
    closeSuccessMessage: function() {
      this.successMessage = null
    },
    submit: function() {
      this.sendState = 'sending';

      var params = {
        "request": {
          "subject": "Postage Refund Requested",
          "comment": {
            "body": "Postage Refund Requested.",
          },

          "custom_fields": [{
              "id": "360007768460",
              "value": this.orderNumber
            },
            {
              "id": "360007768420",
              "value": this.fullName
            },
            {
              "id": "360008703600",
              "value": this.postCode
            },
            {
              "id": "360012110180",
              "value": this.address
            },
            {
              "id": "360012076519",
              "value": this.city
            },
            {
              "id": "360012352839",
              "value": this.country
            }
          ],
          "tags": [
            this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang + "_cancellation"
          ],

          "requester": {
            "email": this.email,
            "role": "end-user",
            "name": this.fullName
          },
        }
      }


        console.log(params)
        axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
          this.fullName = this.email = this.postCode = this.orderNumber  = this.productSKU = this.comment = "";
          console.log(resp.status);
          this.sendState = '';
          this.successMessage = "yes"

        }).catch(error => {
          console.log(error)
        });


    }
  }
}

setInterval(function() {
  window.top.postMessage(document.body.scrollHeight, "*");
}, 150);
</script>
